import React, {
    useState,
} from "react";

import {
    useNavigate,
} from "react-router-dom";

import {
    FaEnvelope,
    FaLock,
    FaUserShield,
} from "react-icons/fa";

import "../styles/admin.css";

import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";

const AdminLogin = () => {

    const [
        data,
        setData,
    ] = useState({

        username: "",
        password: "",

    });

    const [open, setOpen] =
        useState(false);

    const [loading, setLoading] =
        useState(false);

    const [error, setError] =
        useState("");

    const navigate =
        useNavigate();

    const handleLogin =
        async () => {

            setLoading(true);

            setError("");

            try {

                const res =
                    await fetch(
                        "https://stjosephweb.ilakshyaerp.in/api/admin/login",
                        {
                            method:
                                "POST",

                            headers: {
                                "Content-Type":
                                    "application/json",
                            },

                            body: JSON.stringify(
                                data
                            ),
                        }
                    );

                if (
                    !res.ok
                ) {

                    throw new Error();

                }

                const result =
                    await res.json();

                localStorage.setItem(
                    "adminToken",
                    result.token
                );

                navigate(
                    "/admin/dashboard"
                );

            } catch {

                setError(
                    "Invalid Username or Password"
                );

            } finally {

                setLoading(false);

            }
        };

    return (

        <>

            {/* HEADER */}
            <Header
                toggleSidebar={() =>
                    setOpen(true)
                }
            />

            {/* SIDEBAR */}
            <Sidebar
                isOpen={open}
                close={() =>
                    setOpen(false)
                }
            />

            {/* PAGE */}
            <div
                className="
                min-h-screen
                bg-gradient-to-br
                from-[#eef4ff]
                via-[#f8fbff]
                to-[#fff7e8]
                flex
                items-center
                justify-center
                px-4
                py-20
              "
            >

                {/* LOGIN CARD */}
                <div
                    className="
                    w-full
                    max-w-md
                    bg-white/90
                    backdrop-blur-lg
                    rounded-[35px]
                    shadow-2xl
                    overflow-hidden
                    border
                    border-white
                  "
                >

                    {/* TOP */}
                    <div
                        className="
                        bg-gradient-to-r
                        from-[#072F5F]
                        to-[#0b4c99]
                        px-10
                        py-12
                        text-center
                        relative
                      "
                    >

                        {/* ICON */}
                        <div
                            className="
                            w-24
                            h-24
                            rounded-full
                            bg-white
                            flex
                            items-center
                            justify-center
                            mx-auto
                            shadow-lg
                            border-4
                            border-[#d89f12]
                          "
                        >

                            <FaUserShield
                                className="
                                text-[#072F5F]
                                text-4xl
                              "
                            />

                        </div>

                        {/* TITLE */}
                        <h2
                            className="
                            text-4xl
                            font-bold
                            text-white
                            mt-6
                          "
                        >

                            Admin Login

                        </h2>

                        <p
                            className="
                            text-white/80
                            mt-3
                            text-sm
                          "
                        >

                            Secure access to school administration

                        </p>

                    </div>

                    {/* BODY */}
                    <div className="px-8 md:px-10 py-10">

                        {/* ERROR */}
                        {
                            error && (

                                <div
                                    className="
                                    bg-red-100
                                    border
                                    border-red-400
                                    text-red-700
                                    px-5
                                    py-4
                                    rounded-2xl
                                    mb-6
                                    text-sm
                                  "
                                >

                                    ❌ {error}

                                </div>
                            )
                        }

                        {/* USERNAME */}
                        <div className="mb-6">

                            <label
                                className="
                                text-[#072F5F]
                                font-semibold
                                block
                                mb-3
                              "
                            >

                                Username

                            </label>

                            <div
                                className="
                                flex
                                items-center
                                bg-[#f5f8ff]
                                border
                                border-gray-200
                                rounded-2xl
                                px-5
                                h-14
                                transition-all
                                duration-300
                                focus-within:border-[#072F5F]
                                focus-within:shadow-md
                              "
                            >

                                <FaEnvelope
                                    className="
                                    text-[#072F5F]
                                    text-lg
                                  "
                                />

                                <input
                                    type="text"
                                    placeholder="Enter Username"
                                    className="
                                    flex-1
                                    bg-transparent
                                    outline-none
                                    px-4
                                    text-gray-700
                                  "
                                    onChange={(e) =>
                                        setData({
                                            ...data,
                                            username:
                                                e.target.value,
                                        })
                                    }
                                />

                            </div>

                        </div>

                        {/* PASSWORD */}
                        <div className="mb-8">

                            <label
                                className="
                                text-[#072F5F]
                                font-semibold
                                block
                                mb-3
                              "
                            >

                                Password

                            </label>

                            <div
                                className="
                                flex
                                items-center
                                bg-[#f5f8ff]
                                border
                                border-gray-200
                                rounded-2xl
                                px-5
                                h-14
                                transition-all
                                duration-300
                                focus-within:border-[#072F5F]
                                focus-within:shadow-md
                              "
                            >

                                <FaLock
                                    className="
                                    text-[#072F5F]
                                    text-lg
                                  "
                                />

                                <input
                                    type="password"
                                    placeholder="Enter Password"
                                    className="
                                    flex-1
                                    bg-transparent
                                    outline-none
                                    px-4
                                    text-gray-700
                                  "
                                    onChange={(e) =>
                                        setData({
                                            ...data,
                                            password:
                                                e.target.value,
                                        })
                                    }
                                />

                            </div>

                        </div>

                        {/* BUTTON */}
                        <button
                            onClick={
                                handleLogin
                            }
                            disabled={
                                loading
                            }
                            className="
                            w-full
                            bg-gradient-to-r
                            from-[#072F5F]
                            to-[#0b4c99]
                            hover:from-[#d89f12]
                            hover:to-[#f2b71b]
                            text-white
                            font-bold
                            py-4
                            rounded-2xl
                            shadow-lg
                            transition-all
                            duration-300
                            hover:scale-[1.02]
                          "
                        >

                            {
                                loading
                                    ? "Please Wait..."
                                    : "LOGIN"
                            }

                        </button>

                    </div>

                </div>

            </div>

            {/* FOOTER */}
            <Footer />

        </>
    );
};

export default AdminLogin;